module.exports = __webpack_public_path__ + "static/media/aneprem_vote.c0cd2106.png";